import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class FontSource extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'font-src';
    }
    getDirectiveType() {
        return DirectiveType.Fetch;
    }
}
